import Vue from 'vue'
import Router from 'vue-router'
import $store from '@/store.js'
const config = require('../config/index')

const asyncComponent = name => resolve => require([`@/page/${name}`], resolve)

const mainLayout = resolve => require(['@/layout/mainLayout.vue'], resolve) // 主布局
const costLayout = resolve => require(['@/layout/costLayout.vue'], resolve)
const activityLayOut = resolve => require(['@/layout/activityLayOut.vue'], resolve)
const activityH5LayOut = resolve => require(['@/layout/activityH5LayOut.vue'], resolve)

// 以下是页面
const MyOrder = asyncComponent('cost/MyOrder.vue')
const MyOrderConfirm = asyncComponent('cost/MyOrderConfirm.vue')
const PcOrderConfirm = asyncComponent('cost/OrderConfirm/index.vue')
const h5Confirm = asyncComponent('h5/confirm.vue')
const h5Result = asyncComponent('h5/result.vue')
const showPdf = asyncComponent('h5/showPdf.vue')

const MyPresent = asyncComponent('cost/MyPresent.vue')
const MyBill = asyncComponent('cost/MyBill.vue')
const deliveryMage = asyncComponent('cost/deliveryMage.vue')
const BillDetail = asyncComponent('cost/BillDetail.vue')
const resellRecord = asyncComponent('cost/resellRecord.vue')
const Invoice = asyncComponent('cost/Invoice.vue')

// 我的钱包
const MyWallet = asyncComponent('cost/MyWallet.vue')
const Recharge = asyncComponent('cost/Recharge.vue')

// const RechargeOnline = asyncComponent('cost/RechargeOnline.vue')
const tempMidPay = asyncComponent('cost/paymentMidPage.vue')

//
const infoCheck = asyncComponent('companyInfo/infoCheck.vue')
const companyInfo = asyncComponent('companyInfo/companyInfo.vue')
const empower = asyncComponent('cost/empower.vue')
const sureSend = asyncComponent('cost/sureSend.vue')

//
const ElecInvoice = asyncComponent('cost/ElecInvoice.vue')

// 结果页面
// const result = asyncComponent('result/result.vue')
const PcPayResult = asyncComponent('cost/payResult.vue')
const InvoiceResult = asyncComponent('result/InvoiceResult.vue')

// 提现
const applyCash = asyncComponent('cost/applyCash.vue')
const originalPush = Router.prototype.push
Router.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const pages = [
  {
    path: '/',
    component: mainLayout,
    children: [
      {
        path: '/',
        component: costLayout,
        redirect: '/MyOrder',
        children: [
          {
            path: '/MyOrder',
            name: 'MyOrder',
            component: MyOrder,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/AuthOrder',
            name: 'AuthOrder',
            component: MyOrder,
            meta: {
              nav: 'AuthOrder',
            },
          },
          {
            path: '/MyOrder/comfirm',
            name: 'MyOrderConfirm',
            component: PcOrderConfirm,
            meta: {
              nav: 'MyOrder',
            },
            beforeEnter(to, from, next) {
              const { query } = to
              $store.state.isH5
                ? next({
                    path: '/MyOrder/h5Confirm',
                    query,
                  })
                : next()
            },
          },
          {
            path: '/MyOrder/h5Confirm',
            name: 'h5Confirm',
            component: h5Confirm,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/MyOrder/h5Result',
            name: 'h5Result',
            component: h5Result,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/MyOrder/showPdf',
            name: 'showPdf',
            component: showPdf,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/ElecInvoice',
            name: 'ElecInvoice',
            component: ElecInvoice,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/MyOrder/invoice',
            name: 'Invoice',
            component: Invoice,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/MyPresent',
            name: 'MyPresent',
            component: MyPresent,
            meta: {
              nav: 'MyPresent',
            },
          },
          {
            path: '/empower',
            name: 'empower',
            component: empower,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/sureSend',
            name: 'sureSend',
            component: sureSend,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/MyBill',
            name: 'MyBill',
            component: MyBill,
            meta: {
              nav: 'MyBill',
            },
          },
          {
            path: '/deliveryMage',
            name: 'deliveryMage',
            component: deliveryMage,
            meta: {
              nav: 'deliveryMage',
            },
          },
          {
            path: '/BillDetail',
            name: 'BillDetail',
            component: BillDetail,
            meta: {
              nav: 'MyBill',
            },
          },
          {
            path: '/resellRecord',
            name: 'resellRecord',
            component: resellRecord,
            meta: {
              nav: 'MyBill',
            },
          },
          {
            path: '/MyWallet',
            name: 'MyWallet',
            component: MyWallet,
            meta: {
              nav: 'MyWallet',
            },
          },
          {
            path: '/COOPBONUS',
            name: 'COOPBONUS',
            component: MyWallet,
            meta: {
              nav: 'COOPBONUS',
            },
          },
          {
            path: '/applyCash',
            name: 'applyCash',
            component: applyCash,
            meta: {
              nav: 'MyOrder',
            },
          },
          {
            path: '/result',
            name: 'result',
            component: PcPayResult,
          },
          {
            path: '/InvoiceResult',
            name: 'InvoiceResult',
            component: InvoiceResult,
          },
          {
            path: '/MyWallet/Recharge',
            name: 'Recharge',
            component: Recharge,
            meta: {
              nav: 'MyWallet',
            },
          },
          {
            path: '/RechargeOnline',
            name: 'RechargeOnline',
            component: PcOrderConfirm,
            meta: {
              nav: 'MyOrder',
            },
          },
        ],
      },
      {
        path: '/infoCheck',
        name: 'infoCheck',
        component: infoCheck,
        beforeEnter(to, from, next) {
          $store.state.userInfo.realName ? next('/') : next()
        },
      },
      {
        // 公司信息
        path: '/info',
        name: 'info',
        component: companyInfo,
      },
      {
        path: '/tempMidPay',
        name: 'tempMidPay',
        component: tempMidPay,
      },
    ],
  },
  {
    path: 'invitePayment',
    component: activityLayOut,
    redirect: '/invitePayment/main',
    children: [
      {
        path: '/invitePayment/main',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/pc/main.vue'),
        meta: {
          showInviteHeader: true,
        },
        beforeEnter(to, from, next) {
          const { query } = to
          $store.state.isH5
            ? next({
                path: '/invitePaymentH5/main',
                query,
              })
            : next()
        },
      },
      {
        path: '/invitePayment/pay',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/pc/pay.vue'),
        meta: {
          showInviteHeader: true,
        },
      },
      {
        path: '/invitePayment/result',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/pc/result.vue'),
        meta: {
          showInviteHeader: true,
        },
      },
      {
        path: '/invitePayment/pdf',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/pc/pdf.vue'),
        meta: {
          showInviteHeader: false,
        },
      },
    ],
  },
  {
    path: 'invitePaymentH5',
    component: activityH5LayOut,
    redirect: '/invitePayment/main',
    children: [
      {
        path: '/invitePaymentH5/main',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/h5/main.vue'),
      },
      {
        path: '/invitePaymentH5/pay',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/h5/pay.vue'),
      },
      {
        path: '/invitePaymentH5/result',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/h5/result.vue'),
      },
      {
        path: '/invitePaymentH5/pdf',
        name: 'invitePayment',
        component: () => import('@/page/invitePayment/h5/pdf.vue'),
      },
    ],
  },
]
const openEnterprise = window.location.href.indexOf('/open-enterprise') > 0
export default new Router({
  mode: 'history',
  base: window.__POWERED_BY_QIANKUN__ ? (openEnterprise ? '/open-enterprise/billing' : config.microfeOptions.base) : '/',
  routes: [
    {
      path: '*',
      redirect: '/MyOrder',
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['@/page/cost/test.vue'], resolve),
    },
    ...pages,
  ],
})
